import { c as _c } from "react/compiler-runtime";
import React from "react";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
import { ApiDropRater } from "@/generated/models/ApiDropRater";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { ApiDropContextProfileContext } from "@/generated/models/ApiDropContextProfileContext";
interface MemesLeaderboardDropVoteSummaryProps {
  readonly current: number;
  readonly projected: number;
  readonly creditType: string;
  readonly ratersCount: number;
  readonly topVoters: ApiDropRater[];
  readonly userContext?: ApiDropContextProfileContext | null;
}
const MemesLeaderboardDropVoteSummary: React.FC<MemesLeaderboardDropVoteSummaryProps> = t0 => {
  const $ = _c(39);
  const {
    current,
    projected,
    creditType,
    ratersCount,
    topVoters,
    userContext
  } = t0;
  const isPositive = current >= 0;
  const hasUserVoted = userContext?.rating !== undefined && userContext?.rating !== 0;
  const userVote = userContext?.rating ?? 0;
  const isUserVoteNegative = userVote < 0;
  const t1 = `tw-text-sm tw-font-semibold ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
  let t2;
  if ($[0] !== current) {
    t2 = formatNumberWithCommas(current);
    $[0] = current;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== current || $[6] !== projected) {
    t4 = <DropVoteProgressing current={current} projected={projected} />;
    $[5] = current;
    $[6] = projected;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== creditType) {
    t5 = <span className="tw-text-sm tw-text-iron-400 text-nowrap">{creditType} total</span>;
    $[8] = creditType;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-x-1">{t3}{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== topVoters) {
    t7 = topVoters.map(_temp2);
    $[14] = topVoters;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="tw-flex tw-items-center -tw-space-x-1.5">{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== ratersCount) {
    t9 = formatNumberWithCommas(ratersCount);
    $[18] = ratersCount;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <span className="tw-text-sm tw-font-medium tw-text-iron-100">{t9}</span>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = ratersCount === 1 ? "voter" : "voters";
  let t12;
  if ($[22] !== t11) {
    t12 = <span className="tw-text-sm tw-text-iron-400 text-nowrap">{t11}</span>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12) {
    t13 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t10}{t12}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2">{t8}{t13}</div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== creditType || $[31] !== hasUserVoted || $[32] !== isUserVoteNegative || $[33] !== userVote) {
    t15 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">Your vote:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{creditType}</span></span></div></div>;
    $[30] = creditType;
    $[31] = hasUserVoted;
    $[32] = isUserVoteNegative;
    $[33] = userVote;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15 || $[37] !== t6) {
    t16 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2">{t6}{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t6;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
export default MemesLeaderboardDropVoteSummary;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp} data-tooltip-id={`voter-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-size-6 tw-rounded-md tw-ring-2 tw-ring-black tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-size-6 tw-rounded-md tw-ring-2 tw-ring-black tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}